const countryListData = {
  countryListData: [
    {
      code: "AU",
      i18nName: {
        fr: "Australie",
        th: "ออสเตรเลีย",
        "zh-hans": "澳大利亚",
        "zh-hant": "澳大利亞",
      },
      enName: "Australia",
      cluster: "eude",
      continent: "Oceania",
    },
    {
      code: "AT",
      i18nName: {
        fr: "Autriche",
        th: "ออสเตรีย",
        "zh-hans": "奥地利",
        "zh-hant": "奧地利",
      },
      enName: "Austria",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "BE",
      i18nName: {
        fr: "Belgique",
        th: "เบลเยี่ยม",
        "zh-hans": "比利时",
        "zh-hant": "比利時",
      },
      enName: "Belgium",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "CA",
      i18nName: {
        fr: "Canada",
        th: "แคนาดา",
        "zh-hans": "加拿大",
        "zh-hant": "加拿大",
      },
      enName: "Canada",
      cluster: "naus",
      continent: { default: "North America", naus: "Americas" },
    },
    {
      code: "HR",
      i18nName: {
        fr: "Croatie",
        th: "โครเอเชีย",
        "zh-hans": "克罗地亚",
        "zh-hant": "克羅地亞",
      },
      enName: "Croatia",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "CZ",
      i18nName: {
        fr: "République tchèque",
        th: "สาธารณรัฐเช็ก",
        "zh-hans": "捷克共和国",
        "zh-hant": "捷克共和國",
      },
      enName: "Czech Republic",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "DK",
      i18nName: {
        fr: "Danemark",
        th: "เดนมาร์ก",
        "zh-hans": "丹麦",
        "zh-hant": "丹麥",
      },
      enName: "Denmark",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "EE",
      i18nName: {
        fr: "Estonie",
        th: "เอสโตเนีย",
        "zh-hans": "爱沙尼亚",
        "zh-hant": "愛沙尼亞",
      },
      enName: "Estonia",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "FI",
      i18nName: {
        fr: "Finlande",
        th: "ฟินแลนด์",
        "zh-hans": "芬兰",
        "zh-hant": "芬蘭",
      },
      enName: "Finland",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "FR",
      i18nName: {
        fr: "France",
        th: "ฝรั่งเศส",
        "zh-hans": "法国",
        "zh-hant": "法國",
      },
      enName: "France",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "DE",
      i18nName: {
        fr: "Allemagne",
        th: "เยอรมนี",
        "zh-hans": "德国",
        "zh-hant": "德國",
      },
      enName: "Germany",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "GR",
      i18nName: {
        fr: "Grèce",
        th: "กรีซ",
        "zh-hans": "希腊",
        "zh-hant": "希臘",
      },
      enName: "Greece",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "HK",
      i18nName: {
        fr: "Hong Kong, China",
        th: "ฮ่องกง, ประเทศจีน",
        "zh-hans": "中国香港",
        "zh-hant": "香港，中國",
      },
      enName: "Hong Kong, China",
      cluster: "hk",
      continent: "Asia",
    },
    {
      code: "HU",
      i18nName: {
        fr: "Hongrie",
        th: "ฮังการี",
        "zh-hans": "匈牙利",
        "zh-hant": "匈牙利",
      },
      enName: "Hungary",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "ID",
      i18nName: {
        fr: "Indonésie",
        th: "อินโดนีเซีย",
        "zh-hans": "印度尼西亚",
        "zh-hant": "印尼",
      },
      enName: "Indonesia",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "IE",
      i18nName: {
        fr: "Irlande",
        th: "ไอร์แลนด์",
        "zh-hans": "爱尔兰",
        "zh-hant": "愛爾蘭",
      },
      enName: "Ireland",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "IT",
      i18nName: {
        fr: "Italie",
        th: "อิตาลี",
        "zh-hans": "意大利",
        "zh-hant": "義大利",
      },
      enName: "Italy",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "JP",
      i18nName: {
        fr: "Japon",
        th: "ญี่ปุ่น",
        "zh-hans": "日本",
        "zh-hant": "日本",
      },
      enName: "Japan",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "LV",
      i18nName: {
        fr: "Lettonie",
        th: "ลัตเวีย",
        "zh-hans": "拉脱维亚",
        "zh-hant": "拉脫維亞",
      },
      enName: "Latvia",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "LT",
      i18nName: {
        fr: "Lituanie",
        th: "ลิทัวเนีย",
        "zh-hans": "立陶宛",
        "zh-hant": "立陶宛",
      },
      enName: "Lithuania",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "LU",
      i18nName: {
        fr: "Luxembourg",
        th: "ลักเซมเบิร์ก",
        "zh-hans": "卢森堡",
        "zh-hant": "盧森堡",
      },
      enName: "Luxembourg",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "MO",
      i18nName: {
        fr: "Macao, China",
        th: "มาเก๊า, ประเทศจีน",
        "zh-hans": "中国澳门",
        "zh-hant": "澳門，中國",
      },
      enName: "Macao, China",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "MY",
      i18nName: {
        fr: "Malaisie",
        th: "มาเลเซีย",
        "zh-hans": "马来西亚",
        "zh-hant": "馬來西亞",
      },
      enName: "Malaysia",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "NL",
      i18nName: {
        fr: "Pays",
        th: "เนเธอร์แลนด์",
        "zh-hans": "荷兰",
        "zh-hant": "荷蘭",
      },
      enName: "Netherlands",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "NZ",
      i18nName: {
        fr: "Nouvelle",
        th: "นิวซีแลนด์",
        "zh-hans": "新西兰",
        "zh-hant": "紐西蘭",
      },
      enName: "New Zealand",
      cluster: "eude",
      continent: "Oceania",
    },
    {
      code: "PH",
      i18nName: {
        fr: "Philippines",
        th: "ฟิลิปปินส์",
        "zh-hans": "菲律宾",
        "zh-hant": "菲律賓",
      },
      enName: "Philippines",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "PL",
      i18nName: {
        fr: "Pologne",
        th: "โปแลนด์",
        "zh-hans": "波兰",
        "zh-hant": "波蘭",
      },
      enName: "Poland",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "PT",
      i18nName: {
        fr: "Portugal",
        th: "โปรตุเกส",
        "zh-hans": "葡萄牙",
        "zh-hant": "葡萄牙",
      },
      enName: "Portugal",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "SG",
      i18nName: {
        fr: "Singapour",
        th: "สิงคโปร์",
        "zh-hans": "新加坡",
        "zh-hant": "新加坡",
      },
      enName: "Singapore",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "SK",
      i18nName: {
        fr: "Slovaquie",
        th: "สโลวาเกีย",
        "zh-hans": "斯洛伐克",
        "zh-hant": "斯洛伐克",
      },
      enName: "Slovakia",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "SI",
      i18nName: {
        fr: "Slovénie",
        th: "สโลวีเนีย",
        "zh-hans": "斯洛文尼亚",
        "zh-hant": "斯洛維尼亞",
      },
      enName: "Slovenia",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "KR",
      i18nName: {
        fr: "Corée du Sud",
        th: "เกาหลีใต้",
        "zh-hans": "韩国",
        "zh-hant": "韓國",
      },
      enName: "South Korea",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "ES",
      i18nName: {
        fr: "Espagne",
        th: "สเปน",
        "zh-hans": "西班牙",
        "zh-hant": "西班牙",
      },
      enName: "Spain",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "SE",
      i18nName: {
        fr: "Suède",
        th: "สวีเดน",
        "zh-hans": "瑞典",
        "zh-hant": "瑞典",
      },
      enName: "Sweden",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "TW",
      i18nName: {
        fr: "Taiwan, China",
        th: "ไต้หวัน, ประเทศจีน",
        "zh-hans": "中国台湾",
        "zh-hant": "臺灣，中國",
      },
      enName: "Taiwan, China",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "TH",
      i18nName: {
        fr: "Thaïlande",
        th: "ไทย",
        "zh-hans": "泰国",
        "zh-hant": "泰國",
      },
      enName: "Thailand",
      cluster: "thailand",
      continent: "Asia",
    },
    {
      code: "GB",
      i18nName: {
        fr: "Royaume",
        th: "สหราชอาณาจักร",
        "zh-hans": "英国",
        "zh-hant": "英國",
      },
      enName: "United Kingdom",
      cluster: "uk",
      continent: "Europe",
    },
    {
      code: "US",
      i18nName: {
        fr: "États",
        th: "สหรัฐอเมริกา",
        "zh-hans": "美国",
        "zh-hant": "美國",
      },
      enName: "United States",
      cluster: "naus",
      continent: { default: "North America", naus: "Americas" },
    },
    {
      code: "VN",
      i18nName: {
        fr: "Viêt Nam",
        th: "เวียดนาม",
        "zh-hans": "越南",
        "zh-hant": "越南",
      },
      enName: "Vietnam",
      cluster: "eude",
      continent: "Asia",
    },
    {
      code: "BR",
      i18nName: {
        fr: "Brésil",
        th: "บราซิล",
        "zh-hans": "巴西",
        "zh-hant": "巴西",
      },
      enName: "Brazil",
      cluster: "eude",
      continent: { default: "South America", naus: "Americas" },
    },
    {
      code: "CH",
      i18nName: {
        fr: "Suisse",
        th: "สวิตเซอร์แลนด์",
        "zh-hans": "瑞士",
        "zh-hant": "瑞士",
      },
      enName: "Switzerland",
      cluster: "eude",
      continent: "Europe",
    },
    {
      code: "SA",
      i18nName: {
        fr: "Arabie saoudite",
        th: "ซาอุดีอาระเบีย",
        "zh-hans": "沙特阿拉伯",
        "zh-hant": "沙烏地阿拉伯",
      },
      enName: "Saudi Arabia",
      cluster: "eude",
      continent: "Asia",
    },
  ],
};
export default countryListData;
